import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import { useScrollAnimation } from '../AnimatedSection/useScrollAnimation';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';

const GraphicText: React.FC = () => {
    const { t } = useLang('GraphicTextZero');
    const titleAnimation = useScrollAnimation('fadeInUp', { delay: 0 });
    const descAnimation = useScrollAnimation('fadeInUp', { delay: 200 });
    const imageAnimation = useScrollAnimation('fadeInUp', { delay: 400 });

    return (
        <div className={`${styles.GraphicText} GtmModuleData-section`} data-section-id="d3c-GraphicTextZero" id="Power">
            <EcoSpace />
            <div className="container">
                <div className="textContent">
                    <h2 className="title" ref={titleAnimation.ref as React.RefObject<HTMLHeadingElement>} style={titleAnimation.animationStyle}>
                        {t('title')}
                    </h2>
                    <p className="desc" ref={descAnimation.ref as React.RefObject<HTMLParagraphElement>} style={descAnimation.animationStyle}>
                        {t('desc')}
                    </p>
                </div>
                <div className="imageContent" ref={imageAnimation.ref as React.RefObject<HTMLDivElement>} style={imageAnimation.animationStyle}>
                    <EcoImg
                        pc="https://websiteoss.ecoflow.com/figma-uploads/1758252184649-7aench-compressed-10ms%20Auto-Switch.%20%20Zero%20Interruptions..jpg"
                        pad="https://websiteoss.ecoflow.com/figma-uploads/1758252204638-pqoc32-compressed-Charge%20up%2C%20fast%2C%20and%20everywhere.jpg"
                        h5="https://websiteoss.ecoflow.com/figma-uploads/1759060472165-gd85mw-compressed-Charge%20up%2C%20fast%2C%20and%20everywhere.jpg"
                        isOpenLazy={true}
                    />
                </div>
            </div>
            <EcoSpace />
        </div>
    );
};

export default GraphicText;
